import LandingImg from '../../../assets/executives.jpg'
import { FaPeopleGroup } from "react-icons/fa6";
import { BsBuildingFill } from "react-icons/bs";
import { IoBriefcase } from "react-icons/io5";
import { renderCapitalize } from '../../../utils/renderCapitalize';

function Landing() {

    const highLights = [
        {
            icon: FaPeopleGroup,
            title: '1L+ Profiles'
        },
        {
            icon: BsBuildingFill,
            title: '1K+ Companies'
        },
        {
            icon: IoBriefcase,
            title: 'All Domains'
        }
    ]

    return (
        <div className='rounded-[12px] md:rounded-[70px] min-h-[70vh] text-white p-4 py-14 sm:p-8 md:p-20 flex gap-2 flex-wrap sm:flex-nowrap items-center justify-center bg-gradient-to-r from-primary-500 to-secondary-500 mt-10'>
            <div className='w-100'>
                <h2 className='text-3xl sm:text-5xl font-bold'><span className='text-blue-200'>CC ATS</span> for Recruitment Automations</h2>
                <p className='my-5 sm:text-lg text-slate-300'>Hire faster. track smarter. Connect with multiple candidates & clinets across industries.</p>
                <div className='flex gap-2 flex-wrap items-center my-5'>
                    <button className='px-4 py-2 text-lg font-medium rounded-lg border border-white bg-white text-primary-500 hover:scale-[102%] transition-all' onClick={() => window.location.href = "/signin"}>Start Tracking</button>
                    <button className='px-4 py-2 text-lg font-medium rounded-lg border border-white hover:scale-[102%] transition-all' onClick={() => window.location.href = "/signin"}>Try now</button>
                </div>
                <div className='my-5 flex gap-6 flex-wrap items-center'>
                    {
                        highLights?.map((item, i) => (
                            <div className='flex gap-1 items-center' key={i}>
                                <item.icon className='text-secondary-100' />
                                <span>{renderCapitalize(item.title)}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
            <img className='w-full sm:w-2/5 rounded-xl' src={LandingImg} alt="Working together" />
        </div>
    )
}

export default Landing